import { Chart } from 'hqchart'
const chartTime = {
  debug: false,
  precision: 2,
  // tradeTime: [
  //   { Start: 930, End: 1030 },
  //   { Start: 1031, End: 1130 },
  //   { Start: 1301, End: 1400 },
  //   { Start: 1401, End: 1500 },
  // ]
}
// 底部指标工具
export const IndexBar = {
  // Menu: ['RSI', 'MACD', 'KDJ', 'BOLL', 'DMI', 'CCI', 'OBV', 'SKDJ', 'BIAS'],
  Menu: ['MACD', 'KDJ', 'BOLL', 'RSI'],
  Selected: []
}

export const tradeTime = {
  Full: [
    { Start: 930, End: 1000 },
    { Start: 1001, End: 1030 },
    { Start: 1031, End: 1100 },
    { Start: 1101, End: 1130 },
    { Start: 1301, End: 1330 },
    { Start: 1331, End: 1400 },
    { Start: 1401, End: 1430 },
    { Start: 1431, End: 1500 },
  ],
  Simple: [
    { Start: 930, End: 1030 },
    { Start: 1031, End: 1130 },
    { Start: 1301, End: 1400 },
    { Start: 1401, End: 1500 },
  ],
  Min: [
    { Start: 930, End: 1130 },
    { Start: 1301, End: 1500 },
  ],
  GetData: function (w) {
    if (w < 300) return this.Min
    else if (w < 800) return this.Simple
    return this.Full
  }
}

export const xCoordinate = {
  Full: [
    [0, 1, 'RGB(200,200,200)', '09:30'],
    [30, 1, 'RGB(200,200,200)', '10:00'],
    [60, 1, 'RGB(200,200,200)', '10:30'],
    [90, 1, 'RGB(200,200,200)', '11:00'],
    [120, 1, 'RGB(200,200,200)', '11:30'],
    [121, 1, 'RGB(200,200,200)', '13:00'],
    [150, 1, 'RGB(200,200,200)', '13:30'],
    [180, 1, 'RGB(200,200,200)', '14:00'],
    [210, 1, 'RGB(200,200,200)', '14:30'],
    [240, 1, 'RGB(200,200,200)', '15:00'],
  ],
  Simple: [
    [0, 1, 'RGB(200,200,200)', '09:30'],
    [60, 1, 'RGB(200,200,200)', '10:30'],
    [120, 1, 'RGB(200,200,200)', '11:30'],
    [121, 1, 'RGB(200,200,200)', '13:00'],
    [180, 1, 'RGB(200,200,200)', '14:00'],
    [240, 1, 'RGB(200,200,200)', '15:00'],
  ],
  Min: [
    [0, 1, 'RGB(200,200,200)', '09:30'],
    [120, 1, 'RGB(200,200,200)', '11:30'],
    [121, 1, 'RGB(200,200,200)', '13:00'],
    [240, 1, 'RGB(200,200,200)', '15:00'],
  ],
  Count: 241,
  MiddleCount: 60,
  GetData: function (w) {
    if (w < 300) return this.Min
    else if (w < 800) return this.Simple
    return this.Full
  }
}

export const GetMinuteOption = function (symbol) {
  var option = {
    Type: '分钟走势图', // 历史分钟走势图
    Symbol: symbol,
    IsAutoUpdate: true, // 是自动更新数据
    AutoUpdateFrequency: 60000,// 数据更新频率60秒
    Windows: [
      { Index: 'MACD' }
    ],
    DayCount: 1,
    IsShowRightMenu: false, // 右键菜单
    IsShowCorssCursorInfo: true, // 是否显示十字光标的刻度信息
    // 十字光标设置
    CorssCursorInfo: {
      IsShowCorss: true, // 是否显示十字线
      VPenType: 1, // 垂直线类型 0=虚线 1=实线 2=实线线段宽度和K线一样
      HPenType: 1, // 水平线类型 0=虚线 1=实线 -1=隐藏
      // IsOnlyDrawMinute: false, // 分时图十字光标只显示在价格线上
      IsFixXLastTime: true, // 分时图十字光标X轴最右边只能移动到最新的交易时间
    },
    // 边框
    Border: {
      Left: 60, // 左边间距
      Right: 60, // 右边间距
      Top: 30,
      Bottom: 30
    },
    MinuteLine: {
      IsDrawAreaPrice: false,      //是否画价格面积图
    },
    // 标题设置
    KLineTitle: {},
    // 子框架设置,刻度小数位数设置
    Frame: [
      { SplitCount: 5, StringFormat: 0 },
      { SplitCount: 3, StringFormat: 0 },
      { SplitCount: 3, StringFormat: 0 }
    ]
  }

  return option
}

export const GetKLineOption = function () {
  const option = {
    Type: '历史K线图',
    // 窗口指标
    Windows: [
      { Index: '均线' },
      { Index: 'VOL' },
      { Index: 'MACD' }
    ],
    Symbol: null,
    IsApiPeriod: true,// 使用后台api数据
    IsAutoUpdate: true, // 是自动更新数据
    AutoUpdateFrequency: 60000,// 数据更新频率60秒
    IsShowRightMenu: false, // 右键菜单
    IsCorssOnlyDrawKLine: true,// 是否只能在K线上移动
    KLine: {
      DragMode: 1, // 拖拽模式 0 禁止拖拽 1 数据拖拽 2 区间选择
      Right: 0, // 复权 0 不复权 1 前复权 2 后复权
      Period: 0, // 周期 0 日线 1 周线 2 月线 3 年线
      MaxReqeustDataCount: 1000, // 日线数据最近1000天
      MaxRequestMinuteDayCount: 15, // 分钟数据最近15天
      PageSize: 98, // 一屏显示多少数据
      IsShowTooltip: true, // 是否显示K线提示信息
      DrawType: 3 // K线类型 0=实心K线柱子 1=收盘价线 2=美国线 3=空心K线柱子 4= 收盘价面积图
    },
    // 标题设置
    KLineTitle: {},
    // 边框
    Border: {
      Left: 20, // 左边间距
      Right: 60, // 右边间距
      Top: 30
    },
    // 子框架设置
    Frame: [
      { SplitCount: 3, StringFormat: 0, IsShowLeftText: false },
      { SplitCount: 3, StringFormat: 0, IsShowLeftText: false },
      { SplitCount: 3, StringFormat: 0, IsShowLeftText: false },
      { SplitCount: 3, StringFormat: 0, IsShowLeftText: false }
    ]
  }

  return option
}

/**
 * 设置交易时间段
**/
export const setTradeTime = (JSChart, chartW) => {
  let func = JSChart.GetMinuteTimeStringData()
  let coord = JSChart.GetMinuteCoordinateData()
  func.GetET = symbol => {
    return func.CreateTimeData(tradeTime.GetData(chartW))
  }
  coord.GetETData = symbol => {
    return xCoordinate
  }
  Chart.MARKET_SUFFIX_NAME.GetETDecimal = symbol => {
    return chartTime.precision
  }
  Chart.MARKET_SUFFIX_NAME.IsETShowAvPrice = symbol => {
    return true
  }
  Chart.MARKET_SUFFIX_NAME.GetETMarketStatus = symbol => {
    return 2
  }
}

/**
 * 关闭调试信息
 */
export const closeDebug = (Chart) => {
  if (chartTime.debug === false) {
    Chart.JSConsole.Chart.Log = () => { }
    Chart.JSConsole.Complier.Log = () => { }
  }
}

/**
 * 配置分时走势标题更新事件对象
 * @param {*} callback
 */
export const trendTitleCallback = callback => {
  return {
    event: Chart.JSCHART_EVENT_ID.ON_TITLE_DRAW,
    callback: (event, data, obj) => { callback(event, data, obj) }
  }
}

export const getOsInfo = () => {
  var userAgent = navigator.userAgent.toLowerCase()
  var name = 'Unknown'
  var version = 'Unknown'
  if (userAgent.indexOf('win') > -1) {
    name = 'Windows'
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      version = 'Windows 2000'
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      version = 'Windows XP'
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista'
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8'
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1'
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10'
    } else {
      version = 'Unknown'
    }
  } else if (userAgent.indexOf('iphone') > -1) {
    name = 'Iphone'
  } else if (userAgent.indexOf('mac') > -1) {
    name = 'Mac'
  } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
    name = 'Unix'
  } else if (userAgent.indexOf('linux') > -1) {
    if (userAgent.indexOf('android') > -1) {
      name = 'Android'
    } else {
      name = 'Linux'
    }
  } else {
    name = 'Unknown'
  }
  return { name, version }
}
